import type { CustomFieldDefinition } from "@repo/app-types/entities/customField";
import { Size } from "@repo/ui/helpers/helpers";
import { CenteredModal } from "@repo/ui/Modal/centeredModal";
import { ModalHeader } from "@repo/ui/Modal/modalHeader";
import type { FC } from "react";
import { Dialog } from "react-aria-components";
import { EditDataExtractionFieldDefinitionForm } from "./editDataExtractionFieldDefinitionForm.js";

export interface EditDataExtractionFieldDefinitionModalProps {
  field: CustomFieldDefinition | undefined;
  onClose: () => void;
}

export const EditDataExtractionFieldDefinitionModal: FC<
  EditDataExtractionFieldDefinitionModalProps
> = ({ field, onClose }) => {
  return (
    <CenteredModal
      isOpen={!!field}
      onOpenChange={(isOpen) => !isOpen && onClose()}
      isDismissable
      size={Size.LARGE}
    >
      <Dialog className="px-4 pt-5 pb-4 text-left sm:p-6">
        {() => (
          <>
            <ModalHeader isCloseVisible>Edit data extraction field</ModalHeader>

            {field ? (
              <EditDataExtractionFieldDefinitionForm
                field={field}
                onClose={onClose}
              />
            ) : null}
          </>
        )}
      </Dialog>
    </CenteredModal>
  );
};
